import slice from "./spendSlice";

export default slice.reducer;
